import { createRequest, throwResErrors } from "./requestUtil";

export const addComment = ({ data }) => {
	return createRequest()
		.post(`api/comments/trips/${data.tripId}`, { data })
		.then((res) => res.data)
		.catch((error) => throwResErrors(error));
};
